import Row from "@amzn/meridian/row";
import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import React, {useContext} from "react";
import {LogStoreContext} from "../store/context/LogStoreContext";
import MQTTUtility from "../util/MQTTUtility";
import {renderMHELogsTableHeader, renderMHELogsTableRow} from "../util/Util";
import Table from "@amzn/meridian/table";

const LogstreamTabBody = (props) => {
    const {logData} = useContext(LogStoreContext);
    const {isSubscribing, topic, config, setError, intl, onMessage, deviceType, setIsSubscribing} = props;

    const headerProps = {
        topic,
        config,
        onMessage,
        setError,
        setIsSubscribing,
        isSubscribing
    }

    return (
        <Column>
            {isSubscribing && <MQTTUtility {...headerProps}/>}
            <Row alignmentHorizontal="justify" width="100%" widths="fill">
                <Box type="outline" spacingInset="medium">
                    <Table headerRows={1} showDividers={true} spacing="small" stickyHeaderRow={true} layout="fixed">
                        {renderMHELogsTableHeader(intl)}
                        {logData.filteredLogs.map((log) => renderMHELogsTableRow(log, deviceType))}
                    </Table>
                </Box>
            </Row>
        </Column>
    )
}

export default injectIntl(LogstreamTabBody)


// WEBPACK FOOTER //
// ./src/components/commonui/LogstreamTabBody.js